{
  "version": 1,
  "asset_id": "777ebe03-9405-48aa-9f21-37fe03272db1",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/777ebe03-9405-48aa-9f21-37fe03272db1/svc-technical-seo-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/777ebe03-9405-48aa-9f21-37fe03272db1/svc-technical-seo-640.avif",
  "original_filename": "svc-technical-seo-640.avif",
  "size": 8178,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:58Z"
}
